/**
 * Built-in image library for martial arts / fitness programs.
 * Images served from /images/programs/ in the portal's public directory.
 * The user gets a default image per program type, with option to override via custom URL.
 */

const BASE_PATH = '/images/programs';

export const PROGRAM_IMAGES: Record<string, string> = {
  'Kids Martial Arts': `${BASE_PATH}/kids-martial-arts.jpg`,
  'Adult Martial Arts': `${BASE_PATH}/adult-martial-arts.jpg`,
  'Brazilian Jiu-Jitsu': `${BASE_PATH}/bjj.jpg`,
  'Muay Thai': `${BASE_PATH}/muay-thai.jpg`,
  'Karate': `${BASE_PATH}/karate.jpg`,
  'Taekwondo': `${BASE_PATH}/taekwondo.jpg`,
  'Boxing': `${BASE_PATH}/boxing.jpg`,
  'MMA': `${BASE_PATH}/mma.jpg`,
  'Kickboxing': `${BASE_PATH}/kickboxing.jpg`,
  'Fitness / Boot Camp': `${BASE_PATH}/fitness.jpg`,
  'Yoga': `${BASE_PATH}/yoga.jpg`,
  'Self-Defense': `${BASE_PATH}/self-defense.jpg`,
};

export const DEFAULT_PROGRAM_IMAGE = `${BASE_PATH}/default.jpg`;

/**
 * Get the image URL for a program. Falls back to default if no match.
 * If the program has a custom imageUrl set, that takes precedence.
 */
export function getProgramImage(programName: string, customUrl?: string | null): string {
  if (customUrl) return customUrl;
  // Try exact match first, then case-insensitive partial match
  if (PROGRAM_IMAGES[programName]) return PROGRAM_IMAGES[programName];
  const lower = programName.toLowerCase();
  for (const [key, url] of Object.entries(PROGRAM_IMAGES)) {
    if (lower.includes(key.toLowerCase()) || key.toLowerCase().includes(lower)) {
      return url;
    }
  }
  return DEFAULT_PROGRAM_IMAGE;
}

/** All available preset images for the image picker */
export const PROGRAM_IMAGE_OPTIONS = Object.entries(PROGRAM_IMAGES).map(([label, url]) => ({ label, url }));

/**
 * Hero images for website headers (1600x600, cinematic).
 * Used by site-agent for hero sections. Also available in settings.
 */
const HERO_BASE = '/images/heroes';

export const HERO_IMAGES = [
  { label: 'Martial Arts', url: `${HERO_BASE}/martial-arts-1.jpg` },
  { label: 'Kids Class', url: `${HERO_BASE}/kids-class-1.jpg` },
  { label: 'Boxing', url: `${HERO_BASE}/boxing-1.jpg` },
  { label: 'Group Training', url: `${HERO_BASE}/group-training-1.jpg` },
  { label: 'BJJ', url: `${HERO_BASE}/bjj-1.jpg` },
  { label: 'MMA', url: `${HERO_BASE}/mma-1.jpg` },
];

export const DEFAULT_HERO_IMAGE = `${HERO_BASE}/martial-arts-1.jpg`;
